'use client'

import { CalculatorForm, CalculatorSummary, Title } from '@/components'

import { useCalculator } from './useCalculator'

import styles from './Calculator.module.scss'

export const Calculator = () => {
  const { control, isLoading, setValue, watch, handleSubmit, onSubmit } =
    useCalculator()

  return (
    <form className={styles.calculator__form} onSubmit={handleSubmit(onSubmit)}>
      <div>
        <Title
          customClass={styles.calculator__title}
          text={
            <>
              Descubra o <b>plano ideal</b> para você
            </>
          }
        />

        <CalculatorForm control={control} setValue={setValue} watch={watch} />
      </div>

      <CalculatorSummary watch={watch} isLoading={isLoading} />
    </form>
  )
}
